var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconResultSave48Line = function SvgIconResultSave48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 17.4h3.1v4.46h3.4V15.7c0-.26-.07-.51-.18-.75-.02-.03-.03-.06-.05-.1-.07-.13-.16-.25-.27-.36l-6-6c-.11-.11-.23-.19-.36-.27-.03-.02-.06-.04-.1-.05-.23-.11-.48-.18-.74-.18H16.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h7.63v-3.4H16.6a1.9 1.9 0 0 1-1.9-1.9V13.3c0-1.05.85-1.9 1.9-1.9h10.7v3.1c0 1.6 1.3 2.9 2.9 2.9Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 25.02v5.14l-1.68-1.77-2.46 2.35 3.99 4.18a2.564 2.564 0 0 0 3.72 0l3.99-4.18-2.46-2.35-1.68 1.77v-5.14H33.3ZM42 36.84H28v3.4h14v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconResultSave48Line;